const {hiddenEdgeStyle} = require("./ShapeVolume");

const setHiddenEdgeStyle = function(ctx) {
	ctx.lineCap = "butt";
	ctx.globalAlpha = hiddenEdgeStyle.opacity;
	ctx.setLineDash(hiddenEdgeStyle.lineDash);
};

// Assumes context path currently at (x1, y)
const addFake3DCirclePath = function(ctx, x1, x2, y, dir) {
	const dx = Math.abs(x2 - x1);
	const dy = (dir === "top" ? -1 : 1) * dx * 0.13;
	ctx.bezierCurveTo(x1, y + dy, x2, y + dy, x2, y);
};

const drawCone = function(ctx, x, y, w, h, settings = {}) {
	const {fill = null, stroke = null, strokeWidth = null} = settings;
	// Center of base face
	const cx = x + w * 0.5;
	const cy = y + h - w * 0.13;
	// Radius of base face
	const r = w * 0.45;
	// Cone apex
	const apexX = cx;
	const apexY = y + h * 0.13;

	ctx.save();
	ctx.lineCap = "round";
	ctx.beginPath();
	ctx.moveTo(cx + r, cy);
	addFake3DCirclePath(ctx, cx + r, cx - r, cy, "bottom");
	ctx.lineTo(apexX, apexY);
	ctx.closePath();
	if (fill) {
		ctx.fill(fill);
	}
	if (stroke) {
		ctx.strokeStyle = stroke;
		if (strokeWidth) {
			ctx.lineWidth = strokeWidth;
		}
		ctx.stroke();

		ctx.beginPath();
		setHiddenEdgeStyle(ctx);
		ctx.moveTo(cx + r, cy);
		addFake3DCirclePath(ctx, cx + r, cx - r, cy, "top");
		ctx.stroke();
	}
	ctx.restore();
};

const drawCylinder = function(ctx, x, y, w, h, settings = {}) {
	const {fill = null, stroke = null, strokeWidth = null} = settings;
	// Center of top face
	const topX = x + w * 0.5;
	const topY = y + w * 0.13;
	// Center of bottom face
	const botX = x + w * 0.5;
	const botY = y + h - w * 0.13;
	// Radius of base faces
	const r = w * 0.45;

	ctx.save();
	ctx.lineCap = "round";
	ctx.beginPath();
	ctx.moveTo(topX - r, topY);
	addFake3DCirclePath(ctx, topX - r, topX + r, topY, "top");
	ctx.lineTo(botX + r, botY);
	addFake3DCirclePath(ctx, botX + r, botX - r, botY, "bottom");
	ctx.closePath();
	if (fill) {
		ctx.fill(fill);
	}
	if (stroke) {
		ctx.strokeStyle = stroke;
		if (strokeWidth) {
			ctx.lineWidth = strokeWidth;
		}
		ctx.stroke();

		ctx.beginPath();
		ctx.moveTo(topX + r, topY);
		addFake3DCirclePath(ctx, topX + r, topX - r, topY, "bottom");
		ctx.stroke();
		ctx.beginPath();
		setHiddenEdgeStyle(ctx);
		ctx.moveTo(botX + r, botY);
		addFake3DCirclePath(ctx, botX + r, botX - r, botY, "top");
		ctx.stroke();
	}
	ctx.restore();
};

const drawSphere = function(ctx, x, y, w, h, settings = {}) {
	const {fill = null, stroke = null, strokeWidth = null} = settings;
	// Center
	const cx = x + w / 2;
	const cy = y + h / 2;
	// Radius
	const r = w * 0.45;
	// Distance (per-axis) of bezier curve control point from center
	const dxCP = r * 0.5;
	const dyCP = r * 0.3;

	ctx.save();
	ctx.lineCap = "round";
	ctx.beginPath();
	ctx.arc(cx, cy, r, 0, 2 * Math.PI);
	if (fill) {
		ctx.fill(fill);
	}
	if (stroke) {
		ctx.strokeStyle = stroke;
		if (strokeWidth) {
			ctx.lineWidth = strokeWidth;
		}
		ctx.stroke();

		ctx.beginPath();
		ctx.moveTo(cx - r, cy);
		ctx.bezierCurveTo(cx - dxCP, cy + dyCP, cx + dxCP, cy + dyCP, cx + r, cy);
		ctx.stroke();
		ctx.beginPath();
		setHiddenEdgeStyle(ctx);
		ctx.moveTo(cx - r, cy);
		ctx.bezierCurveTo(cx - dxCP, cy - dyCP, cx + dxCP, cy - dyCP, cx + r, cy);
		ctx.stroke();
	}
	ctx.restore();
};

module.exports = {
	cone: drawCone,
	cylinder: drawCylinder,
	sphere: drawSphere,
};
